module.exports = __webpack_public_path__ + "img/img04.56bcc934.jpeg";